import { render, staticRenderFns } from "./HospitalHeader.vue?vue&type=template&id=e4aac69a&"
import script from "./HospitalHeader.vue?vue&type=script&lang=js&"
export * from "./HospitalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports